import React from "react";
import { useTranslation } from "react-i18next";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { OcBadge } from "../badge";
// TODO change to absolute import. Storybook can't handle it.
import { useOcRoleFilterSubtypeHeader } from "./use-role-filter-subtype-header";
import { InlineIcon } from "@iconify/react";
//import { OcBadge } from "oc/components/badge";
import { OcRoleFilterSubtypeProps } from "oc/components/role-filter-subtype/role-filter-subtype";

type OcRoleFilterSubtypeHeaderViewProps = ReturnType<
  typeof useOcRoleFilterSubtypeHeader
> & {
  type: OcRoleFilterSubtypeProps["type"];
  opened: boolean;
  handleOpen: () => void;
  disabled?: boolean;
};
export const OcRoleFilterSubtypeHeaderView: React.FC<
  OcRoleFilterSubtypeHeaderViewProps
> = ({
  icon,
  title,
  subTitle,
  selectedItemsCount,
  type,
  disabled,
  opened,
  handleOpen,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      id={`${type}-collapse-header`}
      sx={{
        display: "flex",
        padding: "0px 12px",
        height: "62px",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "4px",
        backgroundColor:
          !subTitle || disabled
            ? theme.palette.gray30.main
            : theme.palette.white.main,
      }}
    >
      <Box
        id="item-header"
        sx={{
          display: "flex",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <OcBadge badgeContent={disabled ? 0 : selectedItemsCount}>
          <InlineIcon
            icon={icon}
            height={32}
            color={theme.palette.owGray.main}
          />
        </OcBadge>
        {(!subTitle || disabled) && (
          <Typography paddingLeft="20px">{t(title)}</Typography>
        )}
        {subTitle && !disabled && (
          <Box paddingLeft="20px" flexGrow={1}>
            <Typography variant="caption">{t(title)}</Typography>
            <Typography
              sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                width: 0,
                minWidth: "100%",
              }}
            >
              {subTitle}
            </Typography>
          </Box>
        )}
      </Box>
      <IconButton
        id={`${type}-collapse-header-button`}
        sx={{
          height: "24px",
          width: "24px",
          transform: opened && !disabled ? "rotate(-180deg)" : "",
          transition: "transform 0.3s ease-in-out",
        }}
        onClick={handleOpen}
        disabled={disabled}
      >
        <ExpandMore />
      </IconButton>
    </Box>
  );
};
